export default __webpack_public_path__ + "static/media/img4.4c02c0e3.jpg";